'use client'

import { useState } from 'react'
import { signIn, useSession } from 'next-auth/react'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { toast } from '@/lib/toast'
import { isValidEmail, isValidName } from '@/utils/util'
import { register } from '@/utils/request'
import { navigateUrl, resolveRedirect } from '@/utils/client-request'

export function useRegisterForm(vendor: any) {
  const { data: session } = useSession()
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const redirectUrl = searchParams.get('url')

  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleRegister = async (e?: { preventDefault?: () => void }) => {
    e?.preventDefault?.()
    if (!email) return toast.error('Имэйл хаяг хоосон байна')
    if (!firstName) return toast.error('Нэр хоосон байна')
    if (!lastName) return toast.error('Овог хоосон байна')
    if (!password) return toast.error('Нууц үг хоосон байна')
    if (!isValidEmail(email)) return toast.error('Имэйл буруу байна')
    if (!isValidName(firstName)) return toast.error('Нэр буруу байна')
    if (!isValidName(lastName)) return toast.error('Овог буруу байна')
    if (password.length < 8) return toast.error('Нууц үг богинхон байна')

    setLoading(true)
    const currentSessionId = (session as any)?.sessionId
    const response = await register({ email, password, firstName, lastName, phone, vendorId: vendor?.id, sessionId: currentSessionId })
    if (!response) {
      setLoading(false)
      return toast.error('Сервертэй холбогдоход алдаа гарлаа')
    }
    if (response.error) {
      setLoading(false)
      return toast.error(response.error)
    }
    toast.success('Амжилттай бүртгэгдлээ')
    await signIn('credentials', { email, password, sessionId: currentSessionId, vendorId: vendor?.id, redirect: false })
    setTimeout(() => {
      const target = resolveRedirect(redirectUrl, pathname) || navigateUrl('/', pathname)
      if (process.env.NEXT_PUBLIC_ENV === 'production') {
        window.location.href = `${window.location.protocol}//${window.location.host}${target}`
        return
      }
      router.push(target)
    }, 100)
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') handleRegister(event)
  }

  const routeToLogin = () => {
    const target = redirectUrl ? navigateUrl(`/login?url=${redirectUrl}`, pathname) : navigateUrl('/login', pathname)
    if (process.env.NEXT_PUBLIC_ENV === 'production') {
      window.location.href = `${window.location.protocol}//${window.location.host}${target}`
      return
    }
    router.push(target)
  }

  return {
    email, setEmail, phone, setPhone,
    firstName, setFirstName, lastName, setLastName,
    password, setPassword,
    loading,
    handleRegister, handleKeyDown, routeToLogin,
  }
}
